export enum CUSTOMERS_TABLE_COLUMNS {
    FIRST_NAME = 'FirstName',
    LAST_NAME = 'LastName',
    EMAIL = 'Email',
    ID = 'Id',
    ACTIONS = 'Actions',
    INFO = 'Info',
    CREATED_AT = 'CreatedAt',
}

export const CUSTOMERS_DEFAULT_SORT_COLUMN = CUSTOMERS_TABLE_COLUMNS.FIRST_NAME;
export const CUSTOMERS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const CUSTOMERS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const CUSTOMERS_PAGE_DEFAULT_SIZE = 10;

export const CUSTOMERS_TABLE_HEADER = [
    CUSTOMERS_TABLE_COLUMNS.FIRST_NAME,
    CUSTOMERS_TABLE_COLUMNS.LAST_NAME,
    CUSTOMERS_TABLE_COLUMNS.EMAIL,
    CUSTOMERS_TABLE_COLUMNS.ID,
    CUSTOMERS_TABLE_COLUMNS.ACTIONS,
    CUSTOMERS_TABLE_COLUMNS.INFO,
];
